import { REACTIONS, type ReactionId } from '../lib/reactions.js';

/**
 * The audience's voice.
 *
 * Always available, including to listeners with no microphone — for most of the
 * room this is the only way to answer a joke. Kept in the thumb zone (§8) since
 * it is the most-tapped control in the product.
 */
export function ReactionBar({ onReact }: { onReact: (id: ReactionId) => void }) {
  return (
    <div class="reactbar" role="group" aria-label="Send a reaction">
      {REACTIONS.map((reaction) => (
        <button
          key={reaction.id}
          class="reactbar__button"
          onClick={() => onReact(reaction.id)}
          aria-label={reaction.label}
          title={reaction.label}
        >
          <span aria-hidden="true">{reaction.glyph}</span>
        </button>
      ))}
    </div>
  );
}
